import { render, staticRenderFns } from "./WriteLogistics.vue?vue&type=template&id=432f2da6&scoped=true&"
import script from "./WriteLogistics.vue?vue&type=script&lang=js&"
export * from "./WriteLogistics.vue?vue&type=script&lang=js&"
import style0 from "./WriteLogistics.vue?vue&type=style&index=0&id=432f2da6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "432f2da6",
  null
  
)

export default component.exports